<template>
  <div class="container">
    <a-row>
      <a-col :span="4">
        <a-menu
          mode="inline"
          v-model="selectedKeys"
          :openKeys.sync="openKeys"
          :inline-indent="12"
          @click="onMenuClick"
        >
          <template v-for="item in doctree">
            <WsMenuTreeItem
              v-if="Array.isArray(item.children) && item.children.length > 0"
              :key="item.key"
              :menu-info="item"
            />
            <a-menu-item v-else :key="item.key">
              <span>{{ item.title }}</span>
            </a-menu-item>
          </template>
        </a-menu>
      </a-col>
      <a-col :span="20">
        <router-view />
      </a-col>
    </a-row>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { copy } from "@/utils";
import WsMenuTreeItem from "@/components/WsMenuTreeItem";

export default {
  components: {
    WsMenuTreeItem,
  },
  data() {
    return {
      doctree: [],
      content: {},
      openKeys: [],
      selectedKeys: [],
    };
  },
  computed: mapState("common", ["docs"]),
  mounted() {
    this.getDocs().then((res) => {
      this.doctree = this.formatDocs(copy(res || []));
      const openKeys = copy(this.doctree).map((v) => v.key);
      if (this.$route.name == "docs-content") {
        this.$nextTick(() => {
          const { uid } = this.$route.params;
          const doc = this.docs[uid] || {};
          if (uid && doc) {
            this.openKeys = doc.puids.map((v) => "category_" + v);
            this.selectedKeys = ["content_" + uid];
          } else {
            this.openKeys = openKeys;
          }
        });
      } else {
        this.openKeys = openKeys;
      }
    });
  },
  methods: {
    ...mapActions("common", ["getDocs"]),
    formatDocs(data = [], type = "category") {
      data.forEach((item) => {
        item.title = item.title || item.name;
        if (type == "content") {
          item.key = "content_" + item.uid;
        } else {
          item.key = "category_" + item.uid;
          var children = [];
          if (item.contents) {
            children = children.concat(
              this.formatDocs(item.contents, "content")
            );
          }
          if (item.children) {
            children = children.concat(this.formatDocs(item.children));
          }
          if (children.length) {
            item.children = children;
          }
        }
      });
      return data;
    },
    onMenuClick(e) {
      if (/^content_/.test(e.key)) {
        const key = e.key.replace(/^content_/, "");
        const {
          name,
          params: { uid },
        } = this.$route;
        console.info("route", name, uid, key);
        if (name == "docs-content" && uid == key) {
          return;
        }
        this.$router.push("/docs/" + key);
      }
    },
    toggleCollapsed() {
      this.collapsed = !this.collapsed;
    },
  },
};
</script>
<style lang="less">
.ant-space-vertical {
  width: 100%;
}
.container {
  max-width: 1200px;
  padding: 20px;
  margin-left: auto;
  margin-right: auto;
  background-color: #ffffff;
}
</style>
